// extracted by mini-css-extract-plugin
export default {"background":"AnimatedHero_background__NWX2L","blured":"AnimatedHero_blured__pqpO1","bubbles":"AnimatedHero_bubbles__VP2Fc","animate":"AnimatedHero_animate__cDuCt"};